import { Navigate, useParams, useSearchParams } from "react-router-dom";

import {
  buildSalesOrderDetailPath,
  buildSalesOrderOverviewPath,
  INSIDE_SALES_SALES_ORDERS_PATH,
} from "@/lib/hubEntityDetailPaths";

/** Old MRP sales-order pages redirected into Inside Sales. */
export function RedirectMrpSalesOrders() {
  const [searchParams] = useSearchParams();
  const salesOrderId = searchParams.get("sales_order_id")?.trim() ?? "";
  const query = searchParams.get("q")?.trim() || searchParams.get("search")?.trim() || "";
  if (/^\d+$/.test(salesOrderId)) {
    return <Navigate to={buildSalesOrderDetailPath(salesOrderId)} replace />;
  }
  if (query !== "") {
    return <Navigate to={buildSalesOrderOverviewPath(query)} replace />;
  }
  return <Navigate to={INSIDE_SALES_SALES_ORDERS_PATH} replace />;
}

export function RedirectMrpSalesOrderId() {
  const { id = "" } = useParams();
  const trimmed = id.trim();
  if (trimmed === "") {
    return <Navigate to={INSIDE_SALES_SALES_ORDERS_PATH} replace />;
  }
  return <Navigate to={buildSalesOrderDetailPath(trimmed)} replace />;
}
